import { reset } from 'redux-form'

import { SeatTradeSearchResultsFormName } from '../../config/forms'

import { V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE } from '../../actions/users/v1requestChangeUserCustomTOPCode'

export default ({ dispatch }) => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE) {
    return
  }

  dispatch(reset(SeatTradeSearchResultsFormName))
}
